module.exports = __webpack_public_path__ + "static/media/16x9_sample.5812d792.png";